import styled, { css } from 'styled-components'
import IRBg from '../../asserts/images/physical-assessment/bg_recommendation_01.png'

export const Container = styled.div`
  section {
    box-shadow: 0px 4px 4px 0px rgba(38, 67, 130, 0.1);
    margin-bottom: 14px;
    background-color: #ffffff;
  }
`

export const ErrorContainer = styled.div`
  display: flex;
  margin-top: 112px;
  font-size: 18px;
  font-family: Gilroy;
  color: #323f4a;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  .message {
    margin-bottom: 8px;
  }
`

export const SectionStyle = css`
  padding: 97px 200px 100px 200px;
  .ar-section-title {
    height: 70px;
    margin-bottom: 45px;
    font-size: 32px;
    letter-spacing: 0.3px;
    color: rgba(82, 96, 108, 1);
    border-bottom: 1px solid rgba(227, 230, 234, 1);
  }

  h2.ar-section-group-title {
    color: rgba(76, 96, 114, 1);
    font-size: 24px;
    letter-spacing: 0.3px;
    line-height: 36px;
    margin-bottom: 0px;
  }

  h3.ar-section-card-title {
    font-size: 18px;
    font-weight: 600;
    color: #4c6072;
    line-height: 27px;
    letter-spacing: 0.3px;
  }

  .ant-divider-horizontal {
    margin: 32px 0;
  }
  .tags {
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #5a657c;
    display: flex;
    justify-content: flex-end;
    margin-top: -47px;
    padding-bottom: 22px;
    span {
      padding: 4px 20px;
      border: 1px solid rgba(33, 57, 89, 0.2);
      border-radius: 19px;
      margin-left: 16px;
    }
    span:before {
      content: '';
      display: inline-block;
      width: 10px;
      height: 10px;
      border-radius: 10px;
      margin-right: 6px;
    }
    span:first-child:before {
      background: #7fb800;
    }
    span:last-child:before {
      background: #0d2350;
    }
  }
  .range-list {
    display: flex;
    list-style: none;
    font-size: 12px;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    color: rgba(50, 58, 70, 0.5);
    margin: 0;
    li {
      padding-left: 24px;
    }
    span {
      display: inline-block;
      width: 10px;
      height: 10px;
      margin-right: 5px;
    }
  }
  .health-data {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 30px 30px 40px;
    .label {
      white-space: pre-line;
      font-size: 15px;
    }
    .value {
      display: flex;
      align-items: center;
      font-size: 16px;
      color: #4c6072;
      .valid {
        font-size: 12px;
        color: red;
      }
      input {
        background: #edf0f4;
        border-radius: 4px;
        text-align: right;
      }
      span {
        width: 60px;
        display: inline-block;
        margin-right: 20px;
        text-align: right;
      }
    }
  }
  .health-data:nth-child(2n) {
    background: rgba(241, 243, 245, 0.3);
  }
  .body-systems {
    margin-top: 40px;
  }

  .trends-container {
    margin-top: 50px;
    button:first-child {
      text-align: center;
    }
  }
`

export const ClientBasicInfoContainer = styled.section`
  position: relative;
  padding: 20px 18px 60px 50px;
  font-family: Gilroy;
  .header {
    display: flex;
    justify-content: space-between;
    img {
      margin-top: 30px;
      height: 33px;
    }
    button {
      padding: 0 24px;
      height: 40px;
      border: none;
      background-color: #264382;
      font-size: 14px;
      font-weight: 500;
      color: #ffffff;
    }
  }
  .title {
    margin-top: 144px;
    width: 486px;
    font-size: 64px;
    font-weight: 500;
    line-height: 74px;
    color: #323f4a;
  }
  .info-section {
    margin-top: 102px;
    .item {
      display: flex;
      align-items: center;
      font-size: 18px;
      line-height: 27px;
      letter-spacing: 0.3px;
      color: #4c6072;
      font-weight: 500;
      .value {
        margin-left: 8px;
        font-weight: 600;
      }
      &:not(:first-child) {
        margin-top: 4px;
      }
    }
  }
  .tips {
    margin-top: 36px;
    font-family: Inter;
    font-size: 14px;
    font-weight: 600;
    line-height: 17px;
    color: #a1a9b4;
  }
  .bg-section {
    img {
      position: absolute;
    }
    .bg-1 {
      right: 80px;
      bottom: 114px;
    }
    .bg-2 {
      right: 0;
      bottom: 0;
    }
  }
`

export const ScoreColorGroupStyle = styled.div`
  margin-top: 16px;
  margin-bottom: 16px;
  display: flex;
  justify-content: flex-end;
  list-style: none;
  font-size: 12px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: rgba(50, 58, 70, 0.5);
  li {
    padding-left: 24px;
  }
  span {
    display: inline-block;
    width: 10px;
    height: 10px;
    margin-right: 5px;
  }
`

export const RecommendationContainer = styled.section`
  ${SectionStyle}
  padding-top: 106px;
  .edit-btn {
    margin-left: 36px;
    padding: 0 24px;
    height: 40px;
    display: flex;
    align-items: center;
    color: #264382;
    border-color: #264382;
    .icon {
      margin-right: 10px;
    }
  }
  .subtitle {
    font-size: 24px;
    font-weight: 500;
    line-height: 36px;
    letter-spacing: 0.3px;
    color: rgb(76, 96, 114);
  }
  /* 1. Banner Section */
  .banner-section {
    padding: 30px 40px;
    height: 202px;
    border-radius: 8px;
    background: url(${IRBg}) no-repeat center;
    background-size: cover;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .logos-wrapper {
      display: flex;
      align-items: center;
      img {
        margin-right: 18px;
        height: 32px;
      }
    }
    .title {
      font-size: 32px;
      font-weight: 500;
      line-height: 48px;
      letter-spacing: 0.3px;
      color: #ffffff;
    }
  }
  /* 2. Highest Priorities Section */
  .highest-priorities-section {
    padding: 36px 0;
    border-bottom: 1px solid rgba(230, 233, 242, 1);
    .items-section {
      margin: 24px -8px 0;
      display: flex;
      .highest-priority-item {
        margin: 0 8px;
        flex: 1;
        padding: 24px;
        border-radius: 4px;
        border: 1px solid rgba(227, 230, 234, 1);
        background: rgba(250, 250, 250, 1);
        .title-section {
          display: flex;
          justify-content: space-between;
          margin-bottom: 24px;
          padding-bottom: 24px;
          border-bottom: 1px solid rgba(227, 230, 234, 1);
          button {
            padding: 0;
            width: 36px;
            min-width: 36px;
            height: 36px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #eff1f3;
          }
        }
      }
    }
  }
  /* 3. Integrated Recommendation Section */
  .ir-section {
    margin-top: 36px;
    display: flex;
    .editor-section {
      flex: 1;
    }
  }
  /* 4. Exercise, Nutrition, Rejuvenation */
  .step-section {
    margin-top: 60px;
    padding-bottom: 12px;
    border-bottom: 1px solid rgba(230, 233, 242, 1);
    .subtitle {
      margin-bottom: 24px;
    }
    .step-item {
      &:not(:last-child) {
        margin-bottom: 48px;
      }
      .top-section {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .left-section {
          display: flex;
          align-items: center;
          .title {
            margin-left: 16px;
            font-size: 24px;
            font-weight: 500;
            letter-spacing: 0.3px;
          }
        }
        button {
          padding: 0;
          width: 36px;
          height: 36px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #eff1f3;
        }
      }
      .editor-section {
        margin-top: 16px;
      }
    }
  }
  /* 5. Referrals Section */
  .referrals-section {
    margin-top: 60px;
    .top-section {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .add-btn {
        padding: 0 24px;
        height: 40px;
        border-color: rgb(38, 67, 130);
        color: rgb(38, 67, 130);
        &:disabled {
          opacity: 0.7;
        }
      }
    }
    .bottom-section {
      margin-top: 24px;
    }
    /* .add-more-section {
      margin-top: 56px;
      padding-top: 14px;
      border-top: 1px solid rgba(215, 215, 215, 1);
      .add-more-btn {
        padding: 0;
        color: rgba(38, 67, 130, 1);
      }
    } */
  }
`
